import {
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_CartCheckoutData,
  STORE_SHEDULEDateNTime,
  STORE_PROMOTIONS,
  STORE_MERCHANT,
  STORE_DineType,
  STORE_Addons,
  STORE_Cart,
  ENTRY_MODE,
} from "../../database/store-names";
import {
  CONCAT_TEXT_LIMIT,
  HEADER_TAB_SETUP,
  GET_CART_COUNT,
} from "../../functions/funtion";
import { dto_selected_final_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { api_LoadMerchantForMID } from "../../connection/api/api-home";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import { dto_cart_checkout } from "../../classes/dto-cart-checkout";
import { dto_common } from "../../classes/dto-common";
import { Container } from "react-bootstrap";
import { PT_CART } from "../../routes/stack/paths/pt-cart";
import { PT_HOME } from "../../routes/stack/paths/pt-home";
import { Colors } from "../../util/colors";
import Loader from "../../components/loader/loader";
import React from "react";

export default class OrderStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      status: "",
      iserorr: "",
      isDataTrue: false,
      isDeliveredByThirdParty: false,
    };
  }

  async componentDidMount() {
    let status = this.props.params.status;
    let iserorr = this.props.params.iserorr;
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "Order Status",
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_HOME);
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => {},
    });
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    if (entryMode === "QR") {
      const backBtn = document.getElementById("HeaderNavigatorBackButton");
      if (backBtn) {
        backBtn.style.display = "none";
      }
    }

    if (iserorr === "rquaste" || iserorr === "lquasfe") {
      if (iserorr === "rquaste") {
        ENCRYPT_STORAGE.removeMultipleItems([
          STORE_Cart,
          STORE_Addons,
          STORE_FinaleSelelctCartMerchantNZone,
          STORE_PROMOTIONS,
          STORE_SHEDULEDateNTime,
          STORE_CartCheckoutData,
        ]);
        GET_CART_COUNT();
        dto_cart_checkout.Cart = [];
        dto_cart_checkout.Total = 0;
        dto_cart_checkout.TaxTotal = 0;
        dto_cart_checkout.ServiceCharge = 0;
        dto_cart_checkout.DiscountTotal = 0;
        dto_cart_checkout.RowDiscountTotal = 0;
        dto_cart_checkout.SubTotal = 0;
        dto_cart_checkout.DisplaySubtotal = 0;
        dto_cart_checkout.PromoGuid = 0;
        dto_cart_checkout.PromoCODE = "";
        dto_cart_checkout.PromoHeader = "";
        dto_cart_checkout.DiscountPersentage = 0;
        dto_cart_checkout.XMLTaxDoc = [];
        dto_cart_checkout.Comment = "";
      }
      this.setState({
        isDataTrue: true,
        iserorr: iserorr,
        status: status,
        isLoading: false,
      });
    } else {
      this.setState({ isDataTrue: false, isLoading: false });
    }
    await this.isDelBythirdPartisTrue();
  }

  async isDelBythirdPartisTrue() {
    let selectedMID = parseInt(dto_selected_final_merchant_or_product.MID);
    let selectedMerchant = [];
    const SelectedDineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
    if (selectedMID === 76) {
      dto_common.MTYPE = "GR";
      dto_common.ZoneId = 1490;
      let data = await api_LoadMerchantForMID(SelectedDineType, selectedMID);
      let objData = JSON.parse(data);
      let MerchantInfo = JSON.parse(objData.MerchantInfo);
      selectedMerchant = MerchantInfo[0];
    } else {
      let merchants = ENCRYPT_STORAGE.getItem(STORE_MERCHANT);
      let entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
      if (
        merchants === undefined &&
        entryMode === "QR"
      ) {
        let data = await api_LoadMerchantForMID(
          SelectedDineType,
          selectedMID,
          true,
        );
        let objData = JSON.parse(data);
        let MerchantInfo = JSON.parse(objData.MerchantInfo);
        selectedMerchant = MerchantInfo[0];
      } else {
        let selectedMID = parseInt(dto_selected_final_merchant_or_product.MID);
        selectedMerchant = merchants.find(
          (merchant) => merchant.MID === selectedMID,
        );
      }
    }
    const isDeliveredByThirdParty =
      selectedMerchant && selectedMerchant.IDT !== undefined
        ? selectedMerchant.IDT
        : false;
    this.setState({ isDeliveredByThirdParty });
  }

  render() {
    let DineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    if (this.state.isDataTrue) {
      return (
        <Container style={{ marginTop: 50 }}>
          {this.state.isLoading ? (
            <Loader />
          ) : (
            <>
              {this.state.iserorr === "rquaste" ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      textAlign: "center",
                      display: "none",
                      marginTop: "35%",
                    }}
                  >
                    Your Order No is <b>{this.state.status}</b>
                    {CSP === "DT" &&
                    DineType === 4 &&
                    this.state.isDeliveredByThirdParty ? (
                      <p style={{ color: "red", fontWeight: "bold" }}>
                        Note: Delivery of this order will be conducted and
                        charged separately by{" "}
                        {dto_selected_final_merchant_or_product.Merchant}.
                      </p>
                    ) : (
                      ""
                    )}
                  </p>
                  <img
                    src={require("./images/Success.png")}
                    style={{
                      marginTop: "20%",
                      width: "70%",
                      borderRadius: "20px",
                    }}
                    alt=""
                  />
                  <p
                    style={{
                      textAlign: "center",
                      display: "block",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "bold",
                      }}
                    >
                      Thank you for ordering with{" "}
                      {dto_selected_final_merchant_or_product.Merchant}
                    </p>
                    <p>Your order No is <b>{this.state.status}</b></p>
                    {CSP === "DT" &&
                    DineType === 4 &&
                    this.state.isDeliveredByThirdParty ? (
                      <p style={{ color: "red", fontWeight: "bold" }}>
                        Note: Delivery of this order will be conducted and
                        charged separately by{" "}
                        {dto_selected_final_merchant_or_product.Merchant}.
                      </p>
                    ) : (
                      ""
                    )}
                  </p>

                  <div
                    style={{
                      fontWeight: "bold",
                      marginTop: "20px",
                      textAlign: "center",
                      backgroundColor: Colors.DarkGreyScale,
                      color: "white",
                      padding: 15,
                      borderRadius: "10px",
                      display:
                        CSP === "DT" &&
                        (entryMode === "QR" || entryMode === "QR")
                          ? "none"
                          : "block",
                    }}
                    onClick={() => {
                      this.props.navigate(PT_HOME);
                    }}
                  >
                    Shop Again
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={require("./images/CancelInvoice.png")}
                    style={{
                      marginTop: "20%",
                      width: "70%",
                      borderRadius: "20px",
                    }}
                    alt=""
                  />
                  <p style={{ textAlign: "center" }}>
                    {" "}
                    Error : {this.state.status}
                  </p>
                  <div
                    style={{
                      fontWeight: "bold",
                      marginTop: "20px",
                      textAlign: "center",
                      backgroundColor: Colors.DarkGreyScale,
                      color: "white",
                      padding: 15,
                      borderRadius: "10px",
                    }}
                    onClick={() => {
                      this.props.navigate(PT_CART);
                    }}
                  >
                    Back To Cart
                  </div>
                </div>
              )}
            </>
          )}
        </Container>
      );
    } else {
      return null;
    }
  }
}
